'use strict';

const formValidation = require('../components/formValidation');
const clientSideValidation = require('../components/clientSideValidation');
const emailValidation = require('../components/emailValidation');
const passwordValidation = require('../components/passwordValidation');
const createErrorNotification = require('../components/errorNotification');

function bodyFixedOn(isiOS, scrollPosition) {
    if (isiOS) {
        scrollPosition = $(window).scrollTop();
        $('body').addClass('jsModalOpenedIOS');
        $('body').css('top', `-${scrollPosition}px`);
    } else {
        $('body').addClass('jsModalOpened');
    }
}

function bodyFixedOff(isiOS, scrollPosition) {
    if (isiOS) {
        $('body').removeClass('jsModalOpenedIOS');
        $('body').css('top', '');
        $(window).scrollTop(scrollPosition);
    } else {
        $('body').removeClass('jsModalOpened');
    }
}

function popupModal(button, e) {
    const $this = $(button);
    let closeBtnUrl = $this.data('close-btn');
    let closeButton = '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom" onclick="$.magnificPopup.close();"><img src="'
    + closeBtnUrl
    + '"></button>';
    if ($this.hasClass('jsNoDispClose')) {
        closeButton = '';
    }
    let scrollPosition;
    const ua = window.navigator.userAgent.toLowerCase();
    const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
    $.ajax({
        url: $this.attr('href'),
        type: 'get',
        data: [],
    }).done((data) => {
        $.spinner().stop();
        $.magnificPopup.open({
            items: {
                src: data,
                type: 'inline',
            },
            // 規約同意はモダル外クリックでは閉じない
            closeOnBgClick: false,
            mainClass: 'mfp-fade',
            removalDelay: 600,
            closeMarkup: `<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom" onclick="$.magnificPopup.close();"><img src="${closeBtnUrl}"></button>`,
            callbacks: {
                open() {
                    bodyFixedOn(isiOS, scrollPosition);
                },
                close() {
                    bodyFixedOff(isiOS, scrollPosition);
                },
            },
        });
    }).fail((err) => {
        if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
        }
    });
    e.preventDefault();
}

function setAgreementVersion(loginEmail, loginPassword) {
    const signinContent = $('.signin-content')
    const form = $('form.login');
    const url = form.attr('action');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success(data) {
            if (data.success) {
                // 成功時は何もせず画面遷移
                window.location.href = data.redirectUrl;
            } else {
                // 失敗時はエラー表示
                $('.jsModalContentOuter').spinner().stop();
                $.magnificPopup.close();
                const errorMessage = data.error[0];
                signinContent.find('#form-backend-error').html(errorMessage);
            }
        },
        error(data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                // 失敗時はエラー表示
                $('.jsModalContentOuter').spinner().stop();
                $.magnificPopup.close();
                const errorMessage = data.responseJSON.error.errorText;
                signinContent.find('#form-backend-error').html(errorMessage);
            }
        }
    });
    return false;
}

/**
 * 各種バリデーション後にログインし、もし規約同意バージョンが異なる場合はモーダルを表示する。
 * 規約同意バージョンが同一ならばそのままログインする。
 * @param {Event} e - イベント情報
 * @returns {Boolean} false
 */
function login(e){
    $.spinner().start();
    /**
     * フォーム情報取得
     */
    const form = $('form.login');

    /**
     * ログイン用メールアドレス
     * @type {string}
     */
    const loginEmail = $('#login-form-email').val();
    /**
     * ログイン用パスワード
     * @type {string}
     */
    const loginPassword = $('#login-form-password').val();

    // エラーメッセージの除去
    clientSideValidation.functions.clearForm(form.get(0));
    form.find('#form-backend-error').html('');
    let isValidPasswordEmail = true;

    // Eメールアドレスのバリデーションチェック
    if (!emailValidation(loginEmail)) {
        const emailErrorMessage = $('#login-form-email').data('pattern-mismatch');
        $('#login-form-email').addClass('is-invalid');
        form.find('#form-address-error').html(emailErrorMessage);
        isValidPasswordEmail = false;
    }

    // パスワードのバリデーションチェック
    if (!passwordValidation(loginPassword)) {
        const passwordErrorMessage = $('#login-form-password').data('pattern-mismatch');
        $('#login-form-password').addClass('is-invalid');
        form.find('#form-password-error').html(passwordErrorMessage);
        isValidPasswordEmail = false;
    }

    // formのvalidationチェック
    var isValid = clientSideValidation.functions.validateForm(form.get(0), e);
    // validation失敗
    if (!isValidPasswordEmail || !isValid) {
        $.spinner().stop();
        return false;
    }

    const button = $('.jsMagnific#login');
    const url = button.data('loginurl');
    // バックエンドへの送信処理
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        context: button,
        success(data) {
            if (data.success) {
                // 成功時は何もせず画面遷移
                window.location.href = data.redirectUrl;
            } else if(data.isDifferentAgreementVersion){
                // 規約同意バージョンに違いがある場合はダイアログを表示する
                popupModal(this, e);
            } else if (data.isExpiredPassword) {
                // パスワード有効期限切れはリセットページに遷移
                window.location.href = data.redirectUrl;
            } else {
                // 失敗時はエラー表示
                $.spinner().stop();
                const errorMessage = data.error[0];
                form.find('#form-backend-error').html(errorMessage);
            }  
        },
        error(data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                const errorMessage = data.responseJSON.error.errorText;
                form.find('#form-backend-error').html(errorMessage);
                $.spinner().stop();
            }
        }
    });
}

module.exports = {
    login: function() {
        // ログインボタン押下で発火
        $('.jsMagnific#login').click(function (e) {
            login(e);
        });
        // ログインフォーム上でエンターキー押下で発火
        $('form.login').keypress(function(e) {
            if(e.which === 13) {
                login(e);
            }
        });
    },
    showmodal: function () {
        $('.jsMagnific#registration').click(function (e) {
            e.preventDefault();
            $.spinner().start();

            const form = $('form.registration');
            let isValidPasswordEmail = true;

            // エラーメッセージの除去
            clientSideValidation.functions.clearForm(form.get(0));
            // emailの正規表現チェック
            const email = $('#register-email');
            if (!emailValidation(email.val())) {
                email.addClass('is-invalid');
                email.parents('.form-group').find('.invalid-feedback').text(email.data('pattern-mismatch'));
                isValidPasswordEmail = false;
            }
            // Validate email address
            if (email.val().length > 80) {
                email.addClass('is-invalid');
                email.parents('.form-group').find('.invalid-feedback').text(email.data('range-error'));
                isValidPasswordEmail = false;
            }

            // パスワードの正規表現チェック
            const password = $('#register-password');
            if (!passwordValidation(password.val())) {
                password.addClass('is-invalid');
                password.parents('.form-group').find('.invalid-feedback').text(password.data('pattern-mismatch'));
                isValidPasswordEmail = false;
            }

            // formのvalidationチェック
            var isValid = clientSideValidation.functions.validateForm(form.get(0), e);
            // validation失敗
            if (!isValidPasswordEmail || !isValid) {
                $.spinner().stop();
                return false;
            }

            // server-sideでのvalidationチェック
            $.ajax({
                url: $(this).data('checkform'),
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                context: $('.jsMagnific#registration'),
                success: function (data) {
                    if (data.isValid) {
                        popupModal(this, e);
                    } else {
                        $.spinner().stop();
                        formValidation(form, data);
                    }
                },
                error: function (err) {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            });
            return false;
        });
    },
    register: function () {
        $('form.registration').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        location.href = data.redirectUrl;
                    } else {
                        $('.jsModalContentOuter').spinner().stop();
                        $.magnificPopup.close();
                        formValidation(form, data);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $('.jsModalContentOuter').spinner().stop();
                        $.magnificPopup.close();
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                }
            });
            return false;
        });
    },
    submitbtn: function () {
        $('body').on('click', '.jsButtonContinue#submitbtn', function (e) {
            let formName = $(this).data('form-name');
            $(this).prop('disabled', true);
            $('.jsModalContentOuter').spinner().start();
            // 規約同意モダルが新規会員登録から呼び出された場合
            if (formName === 'registration') {
                $('form.registration').trigger('submit');
            // 規約同意モダルがログインから呼び出された場合
            } else if (formName === 'login') {
                // 顧客の規約同意バージョンを更新しログインする
                const loginEmail = $('#login-form-email').val();;
                const loginPassword = $('#login-form-password').val();;
                setAgreementVersion(loginEmail, loginPassword);
            }
            return false;
        });
    }
};
